import { isEqual } from "lodash";
import { DateTime } from "luxon";

export const areFilterPropsEqual = (oldProps, newProps) => {
  return isEqual(oldProps, newProps);
};

export const timeRange = (durationString) => {
  let date = DateTime.local();
  switch (durationString) {
    case "last_week": {
      let lastWeek = date.minus({ weeks: 1 });
      return [lastWeek.startOf("week"), lastWeek.endOf("week")];
    }
    case "last_month": {
      let lastMonth = date.minus({ months: 1 });
      return [lastMonth.startOf("month"), lastMonth.endOf("month")];
    }
    case "month_to_day": {
      let thisMonth = date.minus({ months: 1 });
      return [thisMonth, date];
    }
    case "ytd":
      return [date.startOf("year"), date];
    default:
      return [
        date.minus({ months: 1 }).startOf("month"),
        date.minus({ months: 1 }).endOf("month"),
      ];
  }
};

const controlStyle = (base) => ({
  ...base,
  fontSize: "16px",
  lineHeight: "21px",
  fontWeight: 400,
  height: "48px",
  width: "320px",
  cursor: "pointer",
});

const controlStyleFullWidth = (base) => ({
  ...base,
  fontSize: "16px",
  lineHeight: "21px",
  fontWeight: 400,
  height: "48px",
  cursor: "pointer",
});

const controlStyleDynamicWidth = (base) => ({
  ...base,
  maxWidth: "320px",
  minWidth: "200px",
  width: "100%",
});

const valueContainerStyle = (base) => ({
  ...base,
  height: "48px",
  position: "static",
});

const indicatorsContainerStyle = (base) => ({
  ...base,
  height: "48px",
});

const inputStyle = (base) => ({
  ...base,
  padding: 0,
  margin: 0,
})

export const CustomStyle = {
  control: controlStyle,
  valueContainer: valueContainerStyle,
  indicatorsContainer: indicatorsContainerStyle,
};

export const CustomStyleFullWidth = {
  control: controlStyleFullWidth,
  valueContainer: valueContainerStyle,
  indicatorsContainer: indicatorsContainerStyle,
};

export const CustomStyleDynamicWidth = {
  input: inputStyle,
  control: controlStyleDynamicWidth,
  valueContainer: valueContainerStyle,
  indicatorsContainer: indicatorsContainerStyle,
};
